import React, { useState, useEffect } from 'react';
import { Users, Award, TrendingUp } from 'lucide-react';
import { Card } from '../ui/card';
import { Badge } from '../ui/badge';

export const MembersView = () => {
  const [members, setMembers] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setIsLoading(false);
  }, []);

  const getTierColor = (tier) => {
    switch(tier) {
      case 'Bronze': return 'bg-amber-100 text-amber-700';
      case 'Silver': return 'bg-gray-200 text-gray-700';
      case 'Gold': return 'bg-yellow-100 text-yellow-700';
      default: return 'bg-gray-100 text-gray-700';
    }
  };

  return (
    <Card className="p-6">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h2 className="text-2xl font-bold text-gray-900">VIP Members</h2>
          <p className="text-gray-600">Manage customer memberships and rewards</p>
        </div>
        <div className="flex items-center gap-2">
          <Users className="w-5 h-5 text-gray-600" />
          <span className="text-2xl font-bold text-gray-900">{members.length}</span>
        </div>
      </div>

      {isLoading ? (
        <p className="text-center text-gray-600 py-8">Loading members...</p>
      ) : members.length === 0 ? (
        <div className="text-center py-12">
          <Users className="w-12 h-12 text-gray-300 mx-auto mb-4" />
          <p className="text-gray-600">No members yet</p>
        </div>
      ) : (
        <div className="space-y-4">
          {members.map((member) => (
            <div
              key={member.member_number}
              className="border-2 border-gray-200 rounded-lg p-4"
            >
              {/* Member details */}
            </div>
          ))}
        </div>
      )}
    </Card>
  );
};